import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Card from "./Card";
import { blogsList } from "../../../utils/blogs-list";
import Icons from "../../common/components/Icons";

const BlogsList = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Get the current page from the query parameter, default to 1
  const currentPage = Number(searchParams.get("page")) || 1;
  const itemsPerPage = 3;
  const totalPages = Math.ceil(blogsList.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedItems = blogsList.slice(startIndex, startIndex + itemsPerPage);

  // Handle page navigation
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      navigate(`?page=${newPage}`);

      setTimeout(() => {
        const parent = document.getElementById("blogs-top");
        if (parent) {
          parent.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <>
      <div
        id="blogs-top"
        className="space-y-4 md:space-y-6 pb-10 sm:pb-12 md:pb-14 lg:pb-[60px]">
        {paginatedItems.map((obj, index) => (
          <Card key={index} obj={obj} />
        ))}
      </div>

      {/* Pagination */}
      <div className="flex max-md:justify-center items-center gap-x-3">
        {/* Prev Button */}
        <div
          className={`size-8 md:size-[42px] border border-solid border-custom-blue-v2 rounded-lg flex items-center justify-center group 
            ${
              currentPage === 1
                ? "opacity-40 pointer-events-none"
                : "cursor-pointer hover:bg-custom-blue-v2"
            }`}
          onClick={() => handlePageChange(currentPage - 1)}>
          <Icons
            icon="pagination-arrow"
            className={`group-hover:stroke-white !duration-100 max-md:size-6 ${
              currentPage === 1 ? "pointer-events-none" : ""
            }`}
          />
        </div>

        {/* Page Numbers */}
        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;
          return (
            <div
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={`size-8 md:size-[42px] rounded-lg flex items-center justify-center  !leading-150 text-base md:text-xl font-medium border border-solid border-custom-blue-v2
                ${
                  currentPage !== pageNumber
                    ? "cursor-pointer text-custom-blue-v2 hover:bg-custom-blue-v2/80 hover:text-white "
                    : "hover:bg-opacity-50 bg-custom-blue-v2  text-white pointer-events-none"
                }`}>
              {pageNumber}
            </div>
          );
        })}

        {/* Next Button */}
        <div
          className={`size-8 md:size-[42px] border border-solid border-custom-blue-v2 rounded-lg flex items-center justify-center rotate-180 group
            ${
              currentPage === totalPages
                ? "opacity-40 pointer-events-none"
                : "cursor-pointer hover:bg-custom-blue-v2"
            }`}
          onClick={() => handlePageChange(currentPage + 1)}>
          <Icons
            icon="pagination-arrow"
            className={`group-hover:stroke-white !duration-100 max-md:size-6 ${
              currentPage === totalPages ? "pointer-events-none" : ""
            }`}
          />
        </div>
      </div>
    </>
  );
};

export default BlogsList;
